import styled from 'styled-components';
import { media } from '../../common/components/ui/utils';
import BackgroundImage from '../img/splash_IMG_3933.png';
import BackgroundImageWide from '../img/splash_IMG_3933-wide.png';

const SearchBackground = styled.figure`
  background: url(${BackgroundImage}) 50% 0 no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  backface-visibility: hidden;

  ${media.tabletNarrow`
    background: url(${BackgroundImageWide}) 50% 50% no-repeat;
    background-size: auto;
  `}
`;

export default SearchBackground;



// WEBPACK FOOTER //
// ./src/modules/search/ui/SearchBackground.js